import { Routes } from '@angular/router';
import { RouterComponent } from './router/router.component';
import { SecurityCheckComponent } from './security-check/security-check.component';
import { SurveyCompleteComponent } from './survey-complete/survey-complete.component';
export const routes: Routes = [
    {path: '', component: SecurityCheckComponent},
    { path: 'redirecting', component: RouterComponent, title: "Survey Redirecting Page" },
    {path: 'Survey-Complete',component:SurveyCompleteComponent,title:"Survey complete"},
    {path: '**', redirectTo: ''}
];